import type { EvidenceUploadMode, ModelResults } from 'api';

export const getAnalysisStatusUsingBaleModel = (
  model_results: ModelResults,
  mode: EvidenceUploadMode
): 'rejected-material' | 'accepted' | 'warning' => {
  if (model_results.outputs?.[0]?.highest_grade_name === 'Reject') {
    return 'rejected-material';
  }

  if (mode === 'inspector' && !model_results.outputs?.[0]?.acceptance) {
    // for now just return warning because we've deprecated grade-based
    // rejection and let's see if any updates are needed based on usage
    return 'warning';
  }

  if (model_results.outputs?.[0]?.image_warning) {
    return 'warning';
  }

  return 'accepted';
};
